// extracted by mini-css-extract-plugin
module.exports = {"wrap":"toast_wrap__1mN8g","shell":"toast_shell__1-5Wv","content":"toast_content__3Y05d"};